import { useCallback } from 'react';

export const useScrollTo = () => {
  const scrollTo = useCallback((id, offset = 80) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    } else {
      const maskItem = document.getElementById('maskItem');
      if (maskItem) {
        maskItem.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      }
    }
  }, []);

  return scrollTo;
};
